var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "size": "lg",
      "options": _vm.srList,
      "name": "SrId",
      "placeholder": "Select SR",
      "selected-option": _vm.srItemObj
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.SrId),
      callback: function($$v) {
        _vm.SrId = $$v
      },
      expression: "SrId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.clearSR()
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.srBlockFlag == true) ? _c('div', {
    staticClass: "col-sm-11 pt-2"
  }, [(_vm.setSRCountAllFlag == true) ? _c('b-button', {
    staticClass: "col-sm-2",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSRAllFlag
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsr', 'All')
      }
    }
  }, [_vm._v("All (" + _vm._s(_vm.setSRCountAll) + ")")]) : _vm._e(), _vm._v(" "), (_vm.setSRCountP0Flag == true) ? _c('b-button', {
    staticClass: "col-sm-2 ml-1",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSRP0Flag
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsr', 'P0')
      }
    }
  }, [_vm._v("P0 (" + _vm._s(_vm.setSRCountP0) + ")")]) : _vm._e(), _vm._v(" "), (_vm.setSRCountP1Flag == true) ? _c('b-button', {
    staticClass: "col-sm-2 ml-1",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSRP1Flag
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsr', 'P1')
      }
    }
  }, [_vm._v("P1 (" + _vm._s(_vm.setSRCountP1) + ")")]) : _vm._e(), _vm._v(" "), (_vm.setSRCountP2Flag == true) ? _c('b-button', {
    staticClass: "col-sm-2 ml-1",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSRP2Flag,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsr', 'P2')
      }
    }
  }, [_vm._v("P2 (" + _vm._s(_vm.setSRCountP2) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.svcBlockFlag == true) ? _c('div', {
    staticClass: "col-sm-11 pt-2"
  }, [(_vm.setSVCCountAllFlag == true) ? _c('b-button', {
    staticClass: "col-sm-2",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSVCAllFlag
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsvc', 'All')
      }
    }
  }, [_vm._v("All (" + _vm._s(_vm.setSVCCountAll) + ")")]) : _vm._e(), _vm._v(" "), (_vm.setSVCCountP0Flag == true) ? _c('b-button', {
    staticClass: "col-sm-2 ml-1",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSVCP0Flag
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsvc', 'P0')
      }
    }
  }, [_vm._v("P0 (" + _vm._s(_vm.setSVCCountP0) + ")")]) : _vm._e(), _vm._v(" "), (_vm.setSVCCountP1Flag == true) ? _c('b-button', {
    staticClass: "col-sm-2 ml-1",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSVCP1Flag
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsvc', 'P1')
      }
    }
  }, [_vm._v("P1 (" + _vm._s(_vm.setSVCCountP1) + ")")]) : _vm._e(), _vm._v(" "), (_vm.setSVCCountP2Flag == true) ? _c('b-button', {
    staticClass: "col-sm-2 ml-1",
    attrs: {
      "size": "sm",
      "variant": _vm.activeTabSVCP2Flag,
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        return _vm.changeSelected('pendingsvc', 'P2')
      }
    }
  }, [_vm._v("P2 (" + _vm._s(_vm.setSVCCountP2) + ")\n                    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 pt-2"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.clearSR()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this OFP Shipment List"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('b-input-group', {
    attrs: {
      "right": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPendingShipment),
      expression: "searchPendingShipment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchPendingShipment",
      "type": "text",
      "name": "searchPendingShipment",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchPendingShipment)
    },
    on: {
      "change": _vm.filteredTableData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPendingShipment = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 table-responsive",
    staticStyle: {
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.CountLoading
    },
    on: {
      "update:active": function($event) {
        _vm.CountLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', _vm._l((_vm.PendingColumns), function(col, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center tableheader sticky-header sticky-last"
    }, [_vm._v("\n                                " + _vm._s(col.label) + "\n                            ")])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.showUnallocatedListFilter), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.AssignDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ShipCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.DeliveryUserName))])])
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e15ce830","hasScoped":true}!./src/views/components/newallocationpagev2/ReverseAllOFP/reverseallofp.html
// module id = 1513
// module chunks = 1